<div class="modal-content">
  <div class="container-fluid">
    <br /><br /><br /><br />
    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item"><a href="javascript: void(0);">Home</a></li>
              <li class="breadcrumb-item active">Dashboard</li>
            </ol>
          </div>
          <h4 class="page-title">Terminal Management Audit</h4>
        </div>
      </div>
    </div>
    <!-- end page title -->

    <div class="row" id="content" #content>
      <div class="col-12">

        <h4 class="header-title">Terminal Configs </h4>
        <div *ngIf="!creatingNew">Edit Terminal Config details for your current participant</div>
        <div *ngIf="creatingNew">Create new Terminal Config for your current participant</div>

        <div class="card-box">

          <div *ngIf="raiseWarning">
            <ngb-alert [dismissible]="false">
              <strong>Warning!</strong> {{warning}}
            </ngb-alert>
          </div>

          <ul ngbNav #nav="ngbNav" class="nav nav-tabs" (activeIdChange)="initTable($event)">
            <li [ngbNavItem]="1">
              <a ngbNavLink>Terminal config</a>
              <ng-template ngbNavContent>
                <div class="row">
                  <div class="col-12 mb-2">
                    <form [formGroup]="terminalConfigForm" name="form" autocomplete="off">

                      <div class="row form-horizontal">

                        <div class="col-md-6 form-horizontal px-3">

                          <div class="form-group row">
                            <label for="name" class="col-3 col-form-label">Name</label>
                            <div class="col-9">
                              <input formControlName="name" [disabled]="!!id" class="form-control" id="name" placeholder="">
                              <ul *ngIf="submitted || terminalConfigForm.controls.name.touched" class="parsley-errors-list filled">
                                <li *ngIf="terminalConfigForm.controls.name.hasError('required')" class="parsley-required">Name is required.</li>
                              </ul>
                            </div>
                          </div>

                          <div class="form-group row">
                            <label for="participantId" class="col-3 col-form-label">Participant Id</label>
                            <div class="col-9">
                              <input formControlName="participantId" id="participantId" type="number" class="form-control" placeholder="" disabled="disabled">
                              <ul *ngIf="submitted || terminalConfigForm.controls.participantId.touched" class="parsley-errors-list filled">
                                <li *ngIf="terminalConfigForm.controls.participantId.hasError('required')" class="parsley-required">ParticipantId is required.</li>
                              </ul>
                            </div>
                          </div>

                          <div class="form-group row">
                            <label for="configType" class="col-3 col-form-label">Terminal Config Type</label>
                            <div class="col-9">
                              <ng-select2 formControlName="configType" id="configType" [data]="ConfigTypes" [options]="select2options" placeholder="" (valueChanged)="updateForm()"></ng-select2>
                              <ul *ngIf="submitted || terminalConfigForm.controls.configType.touched" class="parsley-errors-list filled">
                                <li *ngIf="terminalConfigForm.controls.configType.hasError('required')" class="parsley-required">Config type is required.</li>
                              </ul>
                            </div>
                          </div>

                          <div class="form-group row">
                            <label for="active" class="col-3 col-form-label">Active</label>
                            <div class="col-9">
                              <ng-select2 formControlName="active" id="active" [data]="TerminalActivate" [options]="select2options" placeholder=""></ng-select2>
                              <ul *ngIf="submitted || terminalConfigForm.controls.active.touched" class="parsley-errors-list filled">
                                <li *ngIf="terminalConfigForm.controls.active.hasError('required')" class="parsley-required">Active is required.</li>
                              </ul>
                            </div>
                          </div>

                          <div class="form-group row">
                            <label for="type" class="col-3 col-form-label">Terminal Type</label>
                            <div class="col-9">
                              <ng-select2 formControlName="type" id="type" [data]="terminalTypes" [options]="select2options" placeholder=""></ng-select2>
                            </div>
                          </div>

                          <div class="form-group row">
                            <label for="baseCurrency" class="col-3 col-form-label">Base Currency</label>
                            <div class="col-9">
                              <ng-select2 formControlName="baseCurrency" id="baseCurrency" [data]="baseCurrencies" [options]="select2options" placeholder=""></ng-select2>
                              <ul *ngIf="submitted || terminalConfigForm.controls.baseCurrency.touched" class="parsley-errors-list filled">
                                <li *ngIf="terminalConfigForm.controls.baseCurrency.hasError('required')" class="parsley-required">Base currency is required.</li>
                              </ul>
                            </div>
                          </div>

                          <div class="form-group row">
                            <label for="countryCode" class="col-3 col-form-label">Country Code</label>
                            <div class="col-9">
                              <ng-select2 formControlName="countryCode" id="countryCode" [data]="countryCodes" [options]="select2options" [placeholder]=""></ng-select2>
                              <ul *ngIf="submitted || terminalConfigForm.controls.countryCode.touched" class="parsley-errors-list filled">
                                <li *ngIf="terminalConfigForm.controls.countryCode.hasError('required')" class="parsley-required">Country code is required.</li>
                              </ul>
                            </div>
                          </div>

                          <div class="form-group row">
                            <label for="disableHotcards" class="col-3 col-form-label">Disable hot cards</label>
                            <div class="col-9">
                              <input type="number" formControlName="disableHotcards" class="form-control" id="disableHotcards" maxlength="9" placeholder="">
                            </div>
                          </div>

                          <div class="form-group row">
                            <label for="dropIdleConnections" class="col-3 col-form-label">Drop Idle Connections</label>
                            <div class="col-9">
                              <input type="number" formControlName="dropIdleConnections" id="dropIdleConnections" class="form-control" maxlength="9" placeholder="">
                              <ul *ngIf="submitted || terminalConfigForm.controls.dropIdleConnections.touched" class="parsley-errors-list filled">
                                <li *ngIf="terminalConfigForm.controls.dropIdleConnections.hasError('required')" class="parsley-required">Drop Idle Connections is required.</li>
                                <li *ngIf="terminalConfigForm.controls.dropIdleConnections.hasError('min')" class="parsley-error">Drop Idle Connections must be greater than 0.</li>
                              </ul>
                            </div>
                          </div>

                          <div class="form-group row">
                            <label for="daysToKeepStats" class="col-3 col-form-label">Days To Keep Stats</label>
                            <div class="col-9">
                              <input type="number" formControlName="daysToKeepStats" class="form-control" id="daysToKeepStats" maxlength="9" placeholder="">
                            </div>
                          </div>

                          <div class="form-group row">
                            <label for="functionVector" class="col-3 col-form-label">Manual Pan Entry <span class="red-text">(API specific)</span></label>
                            <div class="col-9">
                              <ng-select2 formControlName="functionVector" id="functionVector" [data]="FunctionVectors" [options]="select2options"></ng-select2>
                            </div>
                          </div>

                          <div class="form-group row">
                            <label for="gmtTimeZoneOffset" class="col-3 col-form-label">Gmt Time Zone Offset</label>
                            <div class="col-9">
                              <input formControlName="gmtTimeZoneOffset" class="form-control" id="gmtTimeZoneOffset" maxlength="9" placeholder="">
                            </div>
                          </div>

                          <div class="form-group row">
                            <label for="hardwareConfig" class="col-3 col-form-label">Hardware Config</label>
                            <div class="col-9">
                              <input formControlName="hardwareConfig" class="form-control" id="hardwareConfig" placeholder="">
                            </div>
                          </div>

                          <div class="form-group row">
                            <label for="hotFileId" class="col-3 col-form-label">Hot File Id</label>
                            <div class="col-9">
                              <input formControlName="hotFileId" type="number" class="form-control" id="hotFileId" maxlength="9" placeholder="">
                            </div>
                          </div>

                          <div class="form-group row">
                            <label for="macMasterKey" class="col-3 col-form-label">Mac Master Key</label>
                            <div class="col-9">
                              <input formControlName="macMasterKey" class="form-control" id="macMasterKey" maxlength="20" placeholder="">
                            </div>
                          </div>

                          <div class="form-group row">
                            <label for="mediaTeam" class="col-3 col-form-label">Media Team</label>
                            <div class="col-9">
                              <ng-select2 formControlName="mediaTeam" id="mediaTeam" [data]="mediaTeams" [options]="select2options" placeholder=""></ng-select2>
                            </div>
                          </div>

                          <div class="form-group row">
                            <label for="miscellaneous" class="col-3 col-form-label">Miscellaneous</label>
                            <div class="col-9">
                              <input formControlName="miscellaneous" class="form-control" id="miscellaneous" placeholder="">
                            </div>
                          </div>

                          <div class="form-group row">
                            <label for="mode" class="col-3 col-form-label">Mode</label>
                            <div class="col-9">
                              <input type="number" formControlName="mode" class="form-control" id="mode" maxlength="9" placeholder="">
                            </div>
                          </div>

                          <div class="form-group row">
                            <label for="pinMasterKey" class="col-3 col-form-label">Pin Master Key</label>
                            <div class="col-9">
                              <input formControlName="pinMasterKey" class="form-control" id="pinMasterKey" maxlength="20" placeholder="">
                            </div>
                          </div>

                          <!-- <div class="form-group row">
                  <label for="postalServiceCode" class="col-3 col-form-label">Postal Service Code</label>
                  <div class="col-9">
                    <input formControlName="postalServiceCode" id="postalServiceCode" class="form-control" maxlength="9" placeholder="">
                    <ul *ngIf="submitted || terminalConfigForm.controls.postalServiceCode.touched" class="parsley-errors-list filled">
                      <li *ngIf="terminalConfigForm.controls.postalServiceCode.hasError('required')" class="parsley-required">Postal service code is required.</li>
                    </ul>
                  </div>
                </div> -->

                        </div>
                        <div class="col-md-6 form-horizontal px-3">

                          <div class="form-group row">
                            <label for="sponsorBank" class="col-3 col-form-label">Sponsor Bank</label>
                            <div class="col-9">
                              <input formControlName="sponsorBank" class="form-control" id="sponsorBank" maxlength="8" placeholder="">
                              <ul *ngIf="submitted || terminalConfigForm.controls.sponsorBank.touched" class="parsley-errors-list filled">
                                <li *ngIf="terminalConfigForm.controls.sponsorBank.hasError('required')" class="parsley-required">Sponsor bank is required.</li>
                              </ul>
                            </div>
                          </div>

                          <div class="form-group row">
                            <label for="stateCode" class="col-3 col-form-label">State Code</label>
                            <div class="col-9">
                              <input formControlName="stateCode" class="form-control" id="stateCode" maxlength="2" placeholder="">
                              <ul *ngIf="submitted || terminalConfigForm.controls.stateCode.touched" class="parsley-errors-list filled">
                                <li *ngIf="terminalConfigForm.controls.stateCode.hasError('required')" class="parsley-required">State code is required.</li>
                              </ul>
                            </div>
                          </div>

                          <div class="form-group row">
                            <label for="status" class="col-3 col-form-label">Status</label>
                            <div class="col-9">
                              <input formControlName="status" class="form-control" id="status" placeholder="">
                            </div>
                          </div>

                          <div class="form-group row">
                            <label for="suppliesTeam" class="col-3 col-form-label">Supplies Team</label>
                            <div class="col-9">
                              <ng-select2 formControlName="suppliesTeam" id="suppliesTeam" [data]="suppliesTeams" [options]="select2options" placeholder=""></ng-select2>
                            </div>
                          </div>

                          <div class="form-group row">
                            <label for="supportTeam" class="col-3 col-form-label">Support Team</label>
                            <div class="col-9">
                              <ng-select2 formControlName="supportTeam" id="supportTeam" [data]="supportTeams" [options]="select2options" placeholder=""></ng-select2>
                            </div>
                          </div>

                          <div class="form-group row">
                            <label for="timeZone" class="col-3 col-form-label">Time Zone</label>
                            <div class="col-9">
                              <ng-select2 formControlName="timeZone" id="timeZone" [data]="TimeZone" [options]="select2options"></ng-select2>
                            </div>
                          </div>

                          <div class="form-group row">
                            <label for="valueBars" class="col-3 col-form-label">Value Bars</label>
                            <div class="col-9">
                              <input formControlName="valueBars" class="form-control" id="valueBars" placeholder="">
                            </div>
                          </div>

                          <div class="form-group row">
                            <label for="worstEventSeverity" class="col-3 col-form-label">Worst Event Severity</label>
                            <div class="col-9">
                              <input type="number" formControlName="worstEventSeverity" class="form-control" id="worstEventSeverity" placeholder="">
                              <ul *ngIf="submitted || terminalConfigForm.controls.worstEventSeverity.touched" class="parsley-errors-list filled">
                                <li *ngIf="terminalConfigForm.controls.worstEventSeverity.hasError('required')" class="parsley-required">Worst event severity is required.</li>
                                <li *ngIf="terminalConfigForm.controls.worstEventSeverity.hasError('min')" class="parsley-error">Worst event severity must be greater than 0 and less than 4.</li>
                              </ul>
                            </div>
                          </div>

                          <div class="form-group row">
                            <label for="pOSDataCode" class="col-3 col-form-label">POS Data Code</label>
                            <div class="col-9">
                              <input formControlName="posDataCode" class="form-control" id="posDataCode" maxlength="15" placeholder="">
                              <ul *ngIf="submitted || terminalConfigForm.controls.posDataCode.touched" class="parsley-errors-list filled">
                                <li *ngIf="terminalConfigForm.controls.posDataCode.hasError('required')" class="parsley-required">POS data code is required.</li>
                              </ul>
                            </div>
                          </div>

                          <div class="form-group row">
                            <label for="heartBeat" class="col-3 col-form-label">Heart Beat</label>
                            <div class="col-9">
                              <input formControlName="heartBeat" type="number" class="form-control" id="heartBeat" maxlength="9" placeholder="">
                            </div>
                          </div>

                          <div class="form-group row">
                            <label for="heartbeatDelay" class="col-3 col-form-label">Heart Beat Delay</label>
                            <div class="col-9">
                              <input formControlName="heartbeatDelay" type="number" class="form-control" id="heartbeatDelay" maxlength="9" placeholder="">
                            </div>
                          </div>

                          <div class="form-group row">
                            <label for="timeZoneCode" class="col-3 col-form-label">Time Zone Code</label>
                            <div class="col-9">
                              <ng-select2 formControlName="timeZoneCode" id="timeZoneCode" [data]="timezonecodes" [options]="select2options" placeholder=""></ng-select2>
                            </div>
                          </div>

                          <div class="form-group row">
                            <label for="enableEjUpload" class="col-3 col-form-label">Enable Ej Upload</label>
                            <div class="col-9">
                              <input type="number" formControlName="enableEjUpload" maxlength="9" class="form-control" id="enableEjUpload" placeholder="">
                            </div>
                          </div>

                          <div class="form-group row" *ngIf="displayTAContent">
                            <label for="sampleRate" class="col-3 col-form-label">Sample Rate</label>
                            <div class="col-9">
                              <input type="number" formControlName="sampleRate" class="form-control" maxlength="9" id="sampleRate" placeholder="">
                              <ul *ngIf="submitted || terminalConfigForm.controls.sampleRate.touched" class="parsley-errors-list filled">
                                <li *ngIf="terminalConfigForm.controls.sampleRate.hasError('required')" class="parsley-required">Sample rate is required.</li>
                              </ul>
                            </div>
                          </div>

                          <div class="form-group row" *ngIf="displayTAContent">
                            <label for="bINProfile" class="col-3 col-form-label">BIN Profile</label>
                            <div class="col-9">
                              <ng-select2 id="binProfile" formControlName="binProfile" [data]="bINProfiles" [options]="select2options" placeholder="" maxlength="40"></ng-select2>
                            </div>
                          </div>

                          <div class="form-group row">
                            <label for="echoInterval" class="col-3 col-form-label">Echo Interval</label>
                            <div class="col-9">
                              <input type="number" formControlName="echoInterval" class="form-control" id="echoInterval" maxlength="9" placeholder="">
                            </div>
                          </div>

                          <div class="form-group row">
                            <label for="dUKPTManagement" class="col-3 col-form-label">DUKPT Management</label>
                            <div class="col-9">
                              <input type="number" formControlName="dukptManagement" class="form-control" id="dukptManagement" maxlength="9" placeholder="">
                            </div>
                          </div>

                          <div class="form-group row" *ngIf="displayTAContent">
                            <label for="disableMediaManagement" class="col-3 col-form-label">Disable Media Management</label>
                            <div class="col-9">
                              <input formControlName="disableMediaManagement" type="number" class="form-control" id="disableMediaManagement" placeholder="">
                              <ul *ngIf="submitted || terminalConfigForm.controls.disableMediaManagement.touched" class="parsley-errors-list filled">
                                <li *ngIf="terminalConfigForm.controls.disableMediaManagement.hasError('required')" class="parsley-required">Disable media management is required.</li>
                                <li *ngIf="terminalConfigForm.controls.disableMediaManagement.hasError('min')" class="parsley-error">Disable media management  must be greater than 0.</li>
                              </ul>
                            </div>
                          </div>

                          <div class="form-group row">
                            <label for="TermRktScheme" class="col-3 col-form-label">Term Rkt Scheme</label>
                            <div class="col-9">
                              <input formControlName="termRktScheme" class="form-control" id="termRktScheme" placeholder="">
                            </div>
                          </div>

                          <div class="form-group row">
                            <label for="UsePosDataCodeConfig" class="col-3 col-form-label">Use PosData Code Config</label>
                            <div class="col-9">
                              <input type="number" formControlName="usePosDataCodeConfig" class="form-control" id="usePosDataCodeConfig" maxlength="15" placeholder="">
                            </div>
                          </div>

                          <div class="form-group row">
                            <label for="countyCode" class="col-3 col-form-label">Terminal County Code</label>
                            <div class="col-9">
                              <ng-select2 formControlName="countyCode" id="countyCode" [data]="countryCodes" [options]="select2options" placeholder=""></ng-select2>
                            </div>
                          </div>

                          <div class="form-group row" *ngIf="displayTAContent">
                            <label for="driverId" class="col-3 col-form-label">Driver Id</label>
                            <div class="col-9">
                              <ng-select2 formControlName="driverId" id="driverId" [data]="driverIds" [options]="select2options" placeholder=""></ng-select2>
                              <ul *ngIf="submitted || terminalConfigForm.controls.driverId.touched" class="parsley-errors-list filled">
                                <li *ngIf="terminalConfigForm.controls.driverId.hasError('required')" class="parsley-required">Driver Id is required.</li>
                              </ul>
                            </div>
                          </div>

                          <div class="form-group row">
                            <label for="secModNr" class="col-3 col-form-label">Sec Mod Nr</label>
                            <div class="col-9">
                              <input formControlName="secModNr" class="form-control" id="secModNr" maxlength="16" (keyup)="onKeyUp($event)" placeholder="">
                              <ul *ngIf="submitted || terminalConfigForm.controls.secModNr.touched" class="parsley-errors-list filled">
                                <li *ngIf="terminalConfigForm.controls.secModNr.status == 'INVALID'" class="parsley-required">Sec mod nr requires 16 characters.</li>
                              </ul>
                            </div>
                          </div>

                          <div class="form-group row">
                            <label for="securityTeam" class="col-3 col-form-label">Security Team</label>
                            <div class="col-9">
                              <ng-select2 formControlName="securityTeam" id="securityTeam" [data]="securityTeams" [options]="select2options" placeholder=""></ng-select2>
                            </div>
                          </div>

                        </div>


                        <div class="col-md-12 form-horizontal px-6">
                          <div class="form-group row" *ngIf="!!createResult && createResult.success == false">
                            <div *ngIf="raiseDanger" style="width:100%">
                              <ngb-alert [dismissible]="false" type="danger">
                                <strong>Error!</strong> {{createResult.message}}
                              </ngb-alert>
                            </div>
                          </div>
                        </div>

                        <div class="form-group row float-right">

                        </div>

                      </div>
                    </form>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="page-title-box">
                      <div class="page-title-right">
                        <button *ngIf="canDelete" type="button" class="btn btn-danger waves-effect waves-light float-left m-2" (click)="determineDeleteDialog()" [style]="DeleteButton">
                          <i class="mdi mdi-delete-outline"></i>Delete
                        </button>
                        &nbsp;
                        <button type="submit" class="btn btn-info waves-effect waves-light float-right m-2" [style]="addEditButton" (click)="saveTerminalConfig()">
                          <i class="mdi mdi-content-save"></i>Save
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </li>
            <li [ngbNavItem]="2" *ngIf="editConfig">
              <a ngbNavLink>Terminal groups</a>
              <ng-template ngbNavContent>
                <div class="row">
                  <div class="col-12 mb-2">

                    <div *ngIf="!!participantId" class="card-box">
                      <form class="form-horizontal" role="form" autocomplete="off">

                        <div class="form-group row" *ngIf="canAdd">
                          <div class="col-2">
                            <label for="CustomTags" class="col-form-label">Select a terminal group</label>
                          </div>
                          <div class="col-6">
                            <ng-select2 [(ngModel)]="selectedGroup" [ngModelOptions]="{standalone: true}"
                                        [data]="mapTerminalGroupTags"
                                        [options]="select2options" placeholder="Terminal group"></ng-select2>
                          </div>
                          <div class="col-4">
                            <button class="btn btn-info waves-effect waves-light" (click)="addTerminalGroup()" type="button">
                              Add group<i class="mdi mdi-plus"></i>
                            </button>
                          </div>

                        </div>
                        <hr />

                        <ng-container *ngIf="TerminalGroupsByParticipant && TerminalGroupsByParticipant.length > 0">
                          <div class="form-group row" *ngFor="let groups of TerminalGroupsByParticipant">

                            <div class="col-2">
                              <label for="CardSet" class="col-form-label">Terminal Group</label>
                            </div>
                            <div class="col-2">
                              <ng-select2 [disabled]="true" [(ngModel)]="groups.groupName"
                                          [ngModelOptions]="{standalone: true}"
                                          [data]="terminalGroups" [options]="select2options" placeholder="group"></ng-select2>
                            </div>
                            <div class="col-2">
                              <button class="btn btn-outline-warning  waves-effect waves-light mdi mdi-briefcase-edit"
                                      (click)="linkTags(groups.groupName)" type="button">
                                Link custom tags
                              </button>
                            </div>
                            <div class="col-3">
                              <label for="isAllCustomParam" class="col-12">Set Custom Parameter's values editable</label>
                            </div>
                            <div class="col-1">
                              <input [checked]="groups.customParameterEditable" formControlName="isAllCustomParam" (change)="setCustomParamEditable($event,groups.groupName)" type="checkbox" id="isAllCustomParam" placeholder="Custom parameter editable">
                            </div>
                            <div class="col-2" *ngIf="canAdd">
                              <button class="btn btn-outline-warning  waves-effect waves-light mdi mdi-delete"
                                      (click)="determineGroupDeleteDialog(groups.groupName)" type="button">
                                Delete group
                              </button>
                            </div>


                          </div>
                        </ng-container>

                        <div class="form-group row" offset-3 col-9 *ngIf="error">
                          <div class="col-10">
                            <p class="text-danger">{{errorMessage}}</p>
                          </div>
                        </div>
                        <div class="form-group row offset-3 col-9" *ngIf="!!createResult && createResult.success == false">
                          <ng-container *ngIf="!!createResult.message">
                            <p class="text-danger">{{createResult.message}}</p>
                          </ng-container>
                        </div>


                      </form>
                    </div>

                  </div>
                </div>

              </ng-template>
            </li>
            <li [ngbNavItem]="3" *ngIf="eSocketConfig">
              <a ngbNavLink>eSocket configuration</a>
              <ng-template ngbNavContent>
                <div class="row">
                  <div class="col-12 mb-2">

                    <div *ngIf="!!participantId" class="card-box">
                      <form class="form-horizontal" role="form" autocomplete="off">

                        <app-e-socket-config></app-e-socket-config>

                        <div class="form-group row" offset-3 col-9 *ngIf="error">
                          <div class="col-10">
                            <p class="text-danger">{{errorMessage}}</p>
                          </div>
                        </div>
                        <div class="form-group row offset-3 col-9" *ngIf="!!createResult && createResult.success == false">
                          <ng-container *ngIf="!!createResult.message">
                            <p class="text-danger">{{createResult.message}}</p>
                          </ng-container>
                        </div>


                      </form>
                    </div>

                  </div>
                </div>

              </ng-template>
            </li>
          </ul>

          <div [ngbNavOutlet]="nav" class="tab-pane">
          </div>

        </div>
      </div>
    </div>
    <!-- end -->

  </div>
</div>
